/**
 * Normalize SPA pathnames into stable RUM page IDs by replacing dynamic segments.
 */
export const normalizeRumPageId = (pathname: string): string => {
  let path = pathname;

  path = path.replace(/^\/invitations\/[^/]+/, '/invitations/:feedKey');
  path = path.replace(/^\/datamapping\/[^/]+/, '/datamapping/:mapperGuid');
  path = path.replace(/^\/recipe\/[^/]+/, '/recipe/:exampleId');
  path = path.replace(/^\/adduser\/[^/]+/, '/adduser/:tenantId');
  path = path.replace(/^\/a\/[^/]+/, '/a/:appId');

  path = path.replace(/\/organizations\/[^/]+/, '/organizations/:orgId');
  path = path.replace(/\/projects\/[^/]+/, '/projects/:projectId');
  path = path.replace(/\/env\/[^/]+/, '/env/:envId');

  path = path.replace(/\/tf\/[^/]+/, (segment) => {
    if (segment === '/tf/new') return '/tf/new';
    return '/tf/:recipeId';
  });

  path = path.replace(/\/wiz\/start\/[^/]+/, '/wiz/start/:wizardID');
  path = path.replace(/\/wiz\/[^/]+\/configure/, '/wiz/:transId/configure');
  path = path.replace(/\/wiz\/[^/]+/, (segment) => {
    if (segment === '/wiz/new') return '/wiz/new';
    return '/wiz/:transId';
  });

  path = path.replace(/\/events\/obj\/[^/]+\/edit/, '/events/obj/:objId/edit');
  path = path.replace(/\/events\/obj\/[^/]+/, '/events/obj/:objId');

  return path;
};
